module.exports = __webpack_public_path__ + "static/media/any_devices.b860dd86.jpg";